import { AsyncPipe, NgTemplateOutlet } from '@angular/common'
import { inject, NgModule, Provider } from '@angular/core'

import { LOGIN_AS_SESSION } from './contracts/login-as'
import { CheckAccessDirective } from './directives/check-access.directive'
import { CheckPricingPlanDirective } from './directives/check-pricing-plan.directive'
import { BrowserLocalStorage } from './storage/local.storage'
import { BrowserSessionStorage } from './storage/session.storage'

const STANDALONE_DIRECTIVES = [CheckAccessDirective, CheckPricingPlanDirective]
const PROVIDERS: Provider[] = [
  {
    provide: BrowserLocalStorage,
    useFactory: () => {
      const activeLoginAsSession = inject(LOGIN_AS_SESSION, { optional: true })
      if (activeLoginAsSession) {
        // Overwrite LocalStorage with SessionStorage for Login As session
        return sessionStorage
      }
      return new BrowserLocalStorage()
    },
    deps: [BrowserSessionStorage],
  },
  BrowserSessionStorage,
]

@NgModule({
  imports: [AsyncPipe, NgTemplateOutlet, ...STANDALONE_DIRECTIVES],
  exports: [AsyncPipe, NgTemplateOutlet, ...STANDALONE_DIRECTIVES],
  providers: [...PROVIDERS],
})
export class AppCommonModule {}
